"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloudFunction = exports.isTokenValid = exports.getPercentageVideoWatched = exports.timeStringToSeconds = exports.parseTime = exports.getSecondsFromTimeString = exports.reduceUrlByType = exports.combineAnalytics = exports.returnStructureParam = exports.formatPlatform = exports.formatString = exports.removeItemFromLocalStorage = exports.getLocalStorageItemByKey = exports.saveObjectToLocalStorage = exports.fetchToApi = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("../constants/constants");
var functions_1 = require("firebase/functions");
var fetchToApi = function (_a) {
    var apiEndpointBaseUrl = _a.apiEndpointBaseUrl, url = _a.url, method = _a.method, bodyDataType = _a.bodyDataType, apiToken = _a.apiToken, isAuth = _a.isAuth;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var configPath, response;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    configPath = isAuth ? 'firebaseauth' : 'parsed';
                    return [4 /*yield*/, fetch("".concat(apiEndpointBaseUrl, "/").concat(configPath, "/").concat(url), {
                            method: method,
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: apiToken ? "Bearer ".concat(apiToken) : '',
                            },
                            body: bodyDataType ? JSON.stringify(bodyDataType) : null,
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
exports.fetchToApi = fetchToApi;
var saveObjectToLocalStorage = function (key, obj) {
    try {
        localStorage.setItem(key, JSON.stringify(obj));
    }
    catch (error) {
        console.error("Error while setting item in local storage with key '".concat(key, "': "), error);
    }
};
exports.saveObjectToLocalStorage = saveObjectToLocalStorage;
var getLocalStorageItemByKey = function (key) {
    var localStorageRef = null;
    try {
        var localStorageItem = localStorage.getItem(key);
        if (localStorageItem) {
            localStorageRef = JSON.parse(localStorageItem);
        }
    }
    catch (error) {
        console.error("Error while retrieving item from local storage with key '".concat(key, "': "), error);
    }
    return localStorageRef;
};
exports.getLocalStorageItemByKey = getLocalStorageItemByKey;
var removeItemFromLocalStorage = function (key) {
    try {
        localStorage.removeItem(key);
    }
    catch (error) {
        console.error("Error while removing item from local storage with key '".concat(key, "': "), error);
    }
};
exports.removeItemFromLocalStorage = removeItemFromLocalStorage;
var formatString = function (text) { return text.toLowerCase().replace(/\s/g, ''); };
exports.formatString = formatString;
var formatPlatform = function (platform) {
    if (platform === constants_1.PLATFORMS.SMART_TV) {
        return constants_1.CMS_PLATFORM_QUERY.TV;
    }
    else {
        return constants_1.CMS_PLATFORM_QUERY.RW;
    }
};
exports.formatPlatform = formatPlatform;
var returnStructureParam = function (pageType) {
    if (pageType === constants_1.CMS_DETAILS_ITEM_TYPE.MOVIE || pageType === constants_1.CMS_DETAILS_ITEM_TYPE.SERIE) {
        return constants_1.CMS_ROUTE_DATA.DETAILS;
    }
    else {
        return pageType;
    }
};
exports.returnStructureParam = returnStructureParam;
var combineAnalytics = function (req, appConfig) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var importPromises, analyticsModules, combinedAnalytics;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                importPromises = [];
                // If import regex is provided, process the keys
                if (req) {
                    req.keys().forEach(function (key) {
                        // Instantiate the module from the required context
                        var module = req(key);
                        var video_analytics = appConfig.video_analytics;
                        // Separating the analytics name from the key. (Ex: "./NPAW/videoAnalytics.ts" => "NPAW")
                        var analyticsName = key.split('/')[1];
                        var currentAnalyticsConfig = video_analytics === null || video_analytics === void 0 ? void 0 : video_analytics.find(function (analytics) { return analytics.vendor_name === analyticsName; });
                        var analyticsModule = new module.videoAnalytics(currentAnalyticsConfig);
                        // Push the module into import promises array
                        importPromises.push(analyticsModule);
                    });
                }
                return [4 /*yield*/, Promise.all(importPromises)
                    // Combine multiple analytics modules into a single object
                ];
            case 1:
                analyticsModules = _a.sent();
                combinedAnalytics = {
                    setup: function (videoAnalyticsConfig) {
                        analyticsModules.forEach(function (analyticsModule) {
                            analyticsModule.setup(videoAnalyticsConfig);
                        });
                    },
                    destroy: function () {
                        analyticsModules.forEach(function (analyticsModule) {
                            analyticsModule.destroy && analyticsModule.destroy();
                        });
                    },
                };
                return [2 /*return*/, combinedAnalytics];
        }
    });
}); };
exports.combineAnalytics = combineAnalytics;
var reduceUrlByType = function (elements, withLA) {
    return elements === null || elements === void 0 ? void 0 : elements.reduce(function (obj, _a) {
        var _b;
        var type = _a.type, url = _a.url;
        return Object.assign(obj, (_b = {},
            _b[type.toLowerCase()] = withLA ? { LA_URL: url } : url,
            _b));
    }, {});
};
exports.reduceUrlByType = reduceUrlByType;
var getSecondsFromTimeString = function (time) {
    var seconds = time.split(':').map(Number)[2];
    return seconds;
};
exports.getSecondsFromTimeString = getSecondsFromTimeString;
var parseTime = function (timeString) {
    if (timeString) {
        var _a = timeString.split(':').map(Number), hours = _a[0], minutes = _a[1], seconds = _a[2];
        return { hours: hours, minutes: minutes, seconds: seconds };
    }
    return { hours: 0, minutes: 0, seconds: 0 };
};
exports.parseTime = parseTime;
var timeStringToSeconds = function (timeString) {
    if (timeString) {
        var _a = timeString.split(':').map(Number), hours = _a[0], minutes = _a[1], seconds = _a[2];
        return hours * 3600 + minutes * 60 + seconds;
    }
    return 0;
};
exports.timeStringToSeconds = timeStringToSeconds;
var getPercentageVideoWatched = function (videoDuration, currentTime) {
    if (videoDuration <= 0) {
        return 0;
    }
    var percentageWatched = currentTime / videoDuration;
    return Math.min(Math.max(0, percentageWatched), 1);
};
exports.getPercentageVideoWatched = getPercentageVideoWatched;
var isTokenValid = function (token) {
    try {
        var payload64 = token === null || token === void 0 ? void 0 : token.split('.')[1];
        if (payload64) {
            // Pad the base64 string to be a multiple of 4
            var padding = '='.repeat((4 - (payload64.length % 4)) % 4);
            var paddedPayload64 = payload64 + padding;
            try {
                //Decoding the base64 payload
                var payloadData = JSON.parse(atob(paddedPayload64));
                //Check for the exp value
                var exp = payloadData.exp;
                if (typeof exp === 'number') {
                    // Compare the expiration time with the current time
                    var expirationDate = new Date(exp * 1000);
                    if (expirationDate > new Date()) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }
            catch (error) {
                console.error('Error parsing the token:', error);
            }
        }
        return false;
    }
    catch (error) {
        console.log('Token is null, cannot verify if it is valid');
    }
};
exports.isTokenValid = isTokenValid;
var cloudFunction = function (name, params) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var functions, fn, result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                functions = (0, functions_1.getFunctions)();
                fn = (0, functions_1.httpsCallable)(functions, name);
                return [4 /*yield*/, fn(params)];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result.data];
        }
    });
}); };
exports.cloudFunction = cloudFunction;
